import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './components/auth/AuthProvider'
import { AdminProtectedRoute } from './pages/admin/AdminProtectedRoute'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { VoiceAgentPage } from './pages/VoiceAgentPage'
import ErrorBoundary from './components/ErrorBoundary'
import { ThemeProvider } from './components/ThemeProvider'
import ClientLayout from './client/ClientLayout'
import { LoginPage } from './client/pages/LoginPage'
import { SessionTimeoutPage } from './client/pages/SessionTimeoutPage'
import { LogoutPage } from './client/pages/LogoutPage'
import ClientChatApp from './client/pages/ChatApp'
import { AdminDashboardPage } from './client/pages/AdminDashboardPage'

import './client/theme/ref-theme.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <HashRouter>
        <AuthProvider>
          <ThemeProvider>
            <Routes>
              <Route path="/" element={<ClientLayout />}>
                <Route index element={<Navigate to="/session-timeout" replace />} />
                <Route path="session-timeout" element={<SessionTimeoutPage />} />
                <Route path="logout" element={<LogoutPage />} />
                <Route path="login" element={<LoginPage />} />
                <Route path="chat" element={<Navigate to="/ochat" replace />} />
                <Route path="cchat" element={
                  <ProtectedRoute>
                    <ClientChatApp chatMode="cchat" />
                  </ProtectedRoute>
                } />
                <Route path="ochat" element={
                  <ProtectedRoute>
                    <ClientChatApp chatMode="ochat" />
                  </ProtectedRoute>
                } />
                <Route path="admin" element={
                  <AdminProtectedRoute redirectTo="/session-timeout">
                    <AdminDashboardPage />
                  </AdminProtectedRoute>
                } />
                <Route path="admin/users/:userId" element={
                  <AdminProtectedRoute redirectTo="/session-timeout">
                    <AdminDashboardPage />
                  </AdminProtectedRoute>
                } />
              </Route>

              <Route path="voice-agent" element={
                <ProtectedRoute>
                  <VoiceAgentPage />
                </ProtectedRoute>
              } />
              <Route path="*" element={<Navigate to="/session-timeout" replace />} />
            </Routes>
          </ThemeProvider>
        </AuthProvider>
      </HashRouter>
    </ErrorBoundary>
  </StrictMode>,
)